module.exports = __webpack_public_path__ + "static/media/HOW TO SEND BULK EMAIL IN EZYMIGRATE.90a0e0ff.png";